import { nanoid } from "nanoid";

const applicationList = {
	pagesGroup: [
		{ id: nanoid(), label: '四川省创新型领军企业评估测试', value: 'scienceInnovative', img: 'pen' },
		{ id: nanoid(), label: '四川省高新技术企业评估测试', value: 'technology', img: 'pen' },
		{ id: nanoid(), label: '四川省科技型中小企业评估测试', value: 'science', img: 'pen' },
		{ id: nanoid(), label: '四川省创新型中小企业评估测试', value: 'innovative', img: 'pen' },
		{ id: nanoid(), label: '四川省专精特新中小企业评估测试', value: 'mastery', img: 'pen' },
		{ id: nanoid(), label: '专精特新“小巨人”企业评估测试', value: 'giant', img: 'pen' },
		{ id: nanoid(), label: '企业信用报告在线预览', value: 'report', img: 'report_banner' },
		{ id: nanoid(), label: '后台管理中心', value: 'manage', img: null },
		{ id: nanoid(), label: '中小企业规模类型自测小程序', value: 'scale', img: null },
	],
	qualityNavGroup: [
		{ id: nanoid(), label: '四川省单项冠军中小企业评估测试', value: 'champion', linkText: '单项冠军', isUse: false, reviewType: 8 },
		{ id: nanoid(), label: '专精特新“小巨人”企业评估测试', value: 'giant', linkText: '专精特新小巨人', isUse: true, reviewType: 7 },
		{ id: nanoid(), label: '四川省专精特新中小企业评估测试', value: 'mastery', linkText: '专精特新中小企业', isUse: true, reviewType: 6 },
		{ id: nanoid(), label: '四川省创新型中小企业评估测试', value: 'innovative', linkText: '创新型中小企业', isUse: true, reviewType: 5 },
	],
	scienceNavGroup: [
		{ id: nanoid(), label: '四川省创新型领军企业评估测试', value: 'scienceInnovative', linkText: '创新型领军企业', isUse: false, reviewType: 4 },
		{ id: nanoid(), label: '四川省高新技术企业评估测试', value: 'technology', linkText: '高新技术企业', isUse: true, reviewType: 3 },
		{ id: nanoid(), label: '四川省科技型中小企业评估测试', value: 'science', linkText: '科技型中小企业', isUse: true, reviewType: 2 },
	],
	innovativeResultBtnGroup: [
		{ id: nanoid(), label: '创新性', type: 'cxScore', max: 40, optionName: 'innovateOptions' },
		{ id: nanoid(), label: '成长性', type: 'czScore', max: 30, optionName: 'refinementOptions' },
		{ id: nanoid(), label: '专业化', type: 'zyScore', max: 30, optionName: 'specialityOptions' },
	],
	masteryResultBtnGroup: [
		{ id: nanoid(), label: '专业化', type: 'zyhScore', max: 25, optionName: 'specialityOptions' },
		{ id: nanoid(), label: '精细化', type: 'jxhScore', max: 25, optionName: 'refinementOptions' },
		{ id: nanoid(), label: '特色化', type: 'tshScore', max: 15, optionName: 'featureOptions' },
		{ id: nanoid(), label: '新颖化', type: 'cxnlScore', max: 35, optionName: 'innovateOptions' },
	],
	giantResultBtnGroup: [
		{ id: nanoid(), label: '基础条件', type: 'jcScore', max: 3, optionName: 'foundationOptions' },
		{ id: nanoid(), label: '专业化', type: 'zyScore', max: 3, optionName: 'specialityOptions' },
		{ id: nanoid(), label: '精细化', type: 'jxScore', max: 3, optionName: 'refinementOptions' },
		{ id: nanoid(), label: '特色化', type: 'tsScore', max: 2, optionName: 'featureOptions' },
		{ id: nanoid(), label: '创新能力', type: 'cxScore', max: 5, optionName: 'innovateOptions' },
		{ id: nanoid(), label: '产业链配套', type: 'cylScore', max: 1, optionName: 'industrySupportOptions' },
		{ id: nanoid(), label: '主导产品所属领域', type: 'lyScore', max: 1, optionName: 'regionOptions' },
	],
	scienceResultBtnGroup: [
		{ id: nanoid(), label: '科研人员', type: 'kyryScore', max: 20, optionName: 'personnelOptions' },
		{ id: nanoid(), label: '研发投入', type: 'yftrScore', max: 50, optionName: 'researchOptions' },
		{ id: nanoid(), label: '科技成果', type: 'kjcgScore', max: 30, optionName: 'achievementOptions' },
	],
	technologyResultBtnGroup: [
		{ id: nanoid(), label: '知识产权', type: 'zscqScore', max: 30, optionName: 'IPRoptions' },
		{ id: nanoid(), label: '科技成果转化能力', type: 'kjcgScore', max: 30, optionName: 'achievementOptions' },
		{ id: nanoid(), label: '研究开发组织管理水平', type: 'yjkfScore', max: 20, optionName: 'manageOptions' },
		{ id: nanoid(), label: '企业成长性', type: 'qyczScore', max: 20, optionName: 'refinementOptions' },
	]
}

export default applicationList;